import Backdrop from '@mui/material/Backdrop'

import React from 'react'
// eslint-disable-next-line import/no-unresolved, import/no-extraneous-dependencies
import Lottie from 'lottie-react'
import loaderJson from '@meprism/shared/src/assets/icons/loader.json'

// @TODO: Look at replacing CircularProgress with a custom loader?
// BUT it's nice that it had native cascade support so if you chain 3 loaders,
// it doesn't "reset" its state and jitter as the loads finish.
export const LoadingFallback = () => {
  return (
    <Backdrop open={true} invisible sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: 100, height: 100 }}><Lottie animationData={loaderJson} loop={true} /></div>
    </Backdrop>
  )
}
